import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択する", -1)
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "年", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "0", -1)
const _hoisted_7 = ["value"]

import ValidatableField from '@/components/ValidatableField.vue';
import { RuleExpression, useField } from 'vee-validate';
import { computed, ref, watch } from 'vue';

interface NameObject {
  year: string;
  month: string;
}

interface Props {
  minYear: number;
  maxYear: number;
  name: NameObject;
  label?: string;
  subLabel?: string;
  rules?: {
    year?: RuleExpression<unknown>;
    month?: RuleExpression<unknown>;
  }
  modelValue?: { year: string; month: string };
  isRequired?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'YearMonthSelect',
  props: {
    minYear: null,
    maxYear: null,
    name: null,
    label: { default: '' },
    subLabel: { default: '' },
    rules: { default: undefined },
    modelValue: { default: () => ({ year: '', month: '' }) },
    isRequired: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props as { minYear: number, maxYear: number, name: NameObject, label: string, subLabel: string, rules: {
    year?: RuleExpression<unknown>;
    month?: RuleExpression<unknown>;
  }, modelValue: { year: string; month: string }, isRequired: boolean }





const internalValue = ref({
  year: props.modelValue?.year || '',
  month: props.modelValue?.month || ''
});

watch(() => props.modelValue, (newValue) => {  
  if (newValue) {
    internalValue.value = {
      year: newValue.year || '',
      month: newValue.month || ''
    };
  }
}, { deep: true });

const yearRules = computed(() => {
  const rules = [];
  if (props.rules?.year) rules.push(props.rules.year);
  if (props.isRequired || internalValue.value.month) rules.push('required');
  return rules.join('|');
});

const monthRules = computed(() => {
  const rules = [];
  if (props.rules?.month) rules.push(props.rules.month);
  if (props.isRequired || internalValue.value.year) rules.push('required');
  return rules.join('|');
});

const yearField = useField(props.name.year, yearRules, {
  label: `${props.label}年`,
  initialValue: internalValue.value.year,
});
const monthField = useField(props.name.month, monthRules, {
  label: `${props.label}月`,
  initialValue: internalValue.value.month,
});

watch(() => yearField.value.value, (newVal) => {
  internalValue.value.year = String(newVal);
}, {immediate: true});
watch(() => monthField.value.value, (newVal) => {
  internalValue.value.month = String(newVal);
}, {immediate: true});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ValidatableField, {
      as: "select",
      rules: _unref(yearRules),
      class: _normalizeClass(['p-recommend-form__select', {'--has-value': !!_unref(yearField).value.value}]),
      id: __props.name.year,
      name: __props.name.year,
      label: `${__props.label}年`
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_unref(yearField).value.value && Number(_unref(yearField).value.value) < __props.minYear)
          ? (_openBlock(), _createElementBlock("option", {
              key: 0,
              value: Number(_unref(yearField).value.value),
              selected: "",
              disabled: ""
            }, _toDisplayString(_unref(yearField).value), 9, _hoisted_2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.maxYear - __props.minYear + 1), (i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: __props.minYear + i - 1
          }, _toDisplayString(__props.minYear + i - 1), 9, _hoisted_3))
        }), 128)),
        (_unref(yearField).value.value && Number(_unref(yearField).value.value) > __props.maxYear)
          ? (_openBlock(), _createElementBlock("option", {
              key: 1,
              value: Number(_unref(yearField).value.value),
              selected: "",
              disabled: ""
            }, _toDisplayString(_unref(yearField).value), 9, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rules", "class", "id", "name", "label"]),
    _hoisted_5,
    _createVNode(ValidatableField, {
      as: "select",
      rules: _unref(monthRules),
      class: _normalizeClass(['p-recommend-form__select', {'--has-value': !!_unref(monthField).value.value}]),
      id: __props.name.month,
      name: __props.name.month,
      label: `${__props.label}月`
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
          return _createElementVNode("option", {
            key: i,
            value: i
          }, _toDisplayString(i), 9, _hoisted_7)
        }), 64))
      ]),
      _: 1
    }, 8, ["rules", "class", "id", "name", "label"]),
    _createElementVNode("span", null, _toDisplayString('月' + __props.subLabel), 1)
  ], 64))
}
}

})